import '../components/innerpages/innerpages.scss'

import React from 'react';
import { Helmet } from 'react-helmet';

import CareSection from '../components/innerpages/contact/CareSection';
import ContactForm from '../components/innerpages/contact/ContactForm';
import Header from '../components/innerpages/contact/Header';

function Contact() {
  return (
    <>
      <Helmet>
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>

      <div className="inner-pages-style1 contact-pg-style1">
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <main>
            <Header />
            <ContactForm />
            <CareSection />
          </main>
        </div>
      </div>
    </>
  );
}

export default Contact;
